import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

const DragAndDropItem = ({ data, itemStyle, Item, itemProps, id, index, disabledIds = [] }) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging, hasDragOverlay } = useSortable({
    id,
    disabled: disabledIds.includes(id),
  });

  const style = {
    transform: hasDragOverlay ? 'unset' : CSS.Translate.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
    ...itemStyle,
  };

  return (
    <Item ref={setNodeRef} style={style} index={index} {...attributes} {...listeners} data={data} {...itemProps} />
  );
};

export default DragAndDropItem;
